module.exports = __webpack_public_path__ + "static/media/eliteBronze.54341ef0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/eliteBronze.svg
// module id = 6619
// module chunks = 0